module.exports = __webpack_public_path__ + "img/standard-icon2.c9db48d.svg";